export enum AppealType {
    Rulings = 'Rulings',
    Enforcements = 'Enforcements',
    TT = 'TT'
}

// https://dev0-jira.cbsa-asfc.ca/pages/viewpage.action?pageId=16089902
export enum AppealDocumentCategory {
    Rulings = 'ZRR',
    Enforcements_Ascertain_Forfeiture = 'ZAF',
    Enforcements_Notice_Seizure = 'ZNS',
    Enforcements_Seizure = 'ZSZ',
    Enforcements_Penalty = 'ZRE',
    TT_Denied_Enrolment = 'ZT1',
    TT_Suspended_Authorization = 'ZT2',
    TT_Cancelled_Authorization = 'ZT3',
    SOA_Trade = 'ZRT'
}
